const render = () => {
    return `
        <meta charset="UTF-8">
        <meta name="apple-mobile-web-app-capable" content="yes"/>
        <meta name="fullscreen" content="yes">
        <meta name="x5-fullscreen" content="true">
        <meta name="viewport" content="width=device-width, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover">
        <meta name="msvalidate.01" content="C6365096B98B689B0FE5ABF7E75C9DBC" />
    `;
};

export default render;
